var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1839_41397",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    transform: "rotate(-180 24 24)",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1839_41397)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 22L19 22C19.55 22 20 21.55 20 21C20 20.45 19.55 20 19 20H5C4.45 20 4 20.45 4 21C4 21.55 4.45 22 5 22ZM11 12.586V3C11 2.45 11.45 2 12 2C12.55 2 13 2.45 13 3L13 12.586L16.293 9.293C16.385 9.201 16.496 9.128 16.618 9.077C16.862 8.976 17.138 8.976 17.382 9.077C17.627 9.179 17.821 9.373 17.923 9.618C17.972 9.737 17.997 9.864 17.999 9.992C17.999 9.9935 17.9992 9.99475 17.9995 9.996C17.9997 9.99725 18 9.9985 18 10C18 10.0015 17.9997 10.0028 17.9995 10.004C17.9992 10.0053 17.999 10.0065 17.999 10.008C17.997 10.136 17.972 10.263 17.923 10.382C17.872 10.504 17.799 10.615 17.707 10.707L12.707 15.707C12.6765 15.7375 12.6394 15.7588 12.6021 15.7802C12.5831 15.791 12.5642 15.8019 12.546 15.814C12.529 15.8257 12.5126 15.8382 12.4963 15.8506C12.461 15.8775 12.4261 15.9042 12.385 15.922C12.264 15.973 12.133 16 12 16C11.867 16 11.736 15.973 11.615 15.922C11.575 15.9051 11.5414 15.8794 11.5075 15.8534C11.4913 15.841 11.4751 15.8286 11.458 15.817C11.4405 15.8056 11.4222 15.795 11.4039 15.7845C11.3646 15.7618 11.3251 15.7391 11.293 15.707L6.293 10.707C6.201 10.615 6.128 10.504 6.077 10.382C5.976 10.138 5.976 9.862 6.077 9.618C6.179 9.373 6.374 9.179 6.618 9.077C6.862 8.976 7.138 8.976 7.382 9.077C7.504 9.128 7.615 9.201 7.707 9.293L11 12.586Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download_icon.972ac5d6ced1c461eb8c291ff79fb673.svg";
export { ForwardRef as ReactComponent };